import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface PendingChangesFooterProps {
  changesCount: number;
  onDiscard: () => void;
  onReview: () => void;
  reviewLabel?: string;
  description?: string;
  disabled?: boolean;
}

export const PendingChangesFooter = ({
  changesCount,
  onDiscard,
  onReview,
  reviewLabel = 'Review and save',
  description = 'Review your changes before saving',
  disabled = false,
}: PendingChangesFooterProps) => {
  if (changesCount === 0) return null;

  return (
    <div className='fixed bottom-6 right-6 z-50'>
      <Card className='shadow-lg'>
        <CardContent>
          <div className='flex items-center gap-4'>
            <div>
              <p className='text-sm font-medium'>
                {changesCount} unsaved change
                {changesCount !== 1 ? 's' : ''}
              </p>
              <p className='text-xs text-muted-foreground'>{description}</p>
            </div>
            <div className='flex gap-2'>
              <Button
                variant='outline'
                size='sm'
                onClick={onDiscard}
                disabled={disabled}
              >
                Discard
              </Button>
              <Button size='sm' onClick={onReview} disabled={disabled}>
                {reviewLabel}
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
